
import { useState, useEffect } from "react";
import { getClientCommissionRequests } from "@/services/commission.service";
import { CommissionRequest } from "@/types/commission.types";

export const useClientCommissionRequests = (clientId: string) => {
  const [requests, setRequests] = useState<CommissionRequest[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const ITEMS_PER_PAGE = 6;

  useEffect(() => {
    const fetchRequests = async () => {
      if (!clientId) {
        setRequests([]);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setIsError(false);
      setError(null);

      try {
        const allRequests = await getClientCommissionRequests(clientId);
        
        // Calculando o total de itens
        setTotalCount(allRequests.length);
        
        // Aplicando paginação nos resultados
        const startIndex = (page - 1) * ITEMS_PER_PAGE;
        const endIndex = startIndex + ITEMS_PER_PAGE;
        const paginatedRequests = allRequests.slice(startIndex, endIndex);
        
        setRequests(paginatedRequests);
      } catch (err) {
        console.error("Erro ao buscar comissões contratadas:", err);
        setIsError(true);
        setError(err instanceof Error ? err : new Error("Erro desconhecido"));
        setRequests([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRequests();
  }, [clientId, page]);

  return {
    requests,
    isLoading,
    isError,
    error,
    page,
    setPage,
    totalCount
  };
};
